import { render } from "./contractors.vue?vue&type=template&id=bc8f1ec2"
import script from "./contractors.vue?vue&type=script&lang=js"
export * from "./contractors.vue?vue&type=script&lang=js"
script.render = render

export default script